import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useI18n } from "i18n";
import logger from "logging/logger";
import { Dialog } from "@remo-co/ui-core/src/components/Dialog";
import withDialog from "modules/eventLanding/eventRegistration/withDialog";
import { usePlaceTicketOrder } from "modules/ticketing/hooks/usePlaceTicketOrder";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { useSelector } from "react-redux";
import { selectCurrentEvent } from "modules/event/selectors";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { useNeedHelp } from "modules/helpChat/hooks/useNeedHelp";
import { useStyles } from "./styles";

const PageLoadingWithDialog = withDialog(PageLoader);

export const PlaceTicketOrderDialog = () => {
  const styles = useStyles();
  const location = useLocation();
  const { callApi } = useNeedHelp();
  const [orderReferenceId, setOrderReferenceId] = useState<string | null>(null);
  const event = useSelector(selectCurrentEvent);
  const { t } = useI18n(["event", "eventLanding"]);
  const { placeTicketOrder, status } = usePlaceTicketOrder(
    orderReferenceId,
    event?.id,
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const ecReference = queryParams.get("ec_reference");
    if (ecReference) {
      setOrderReferenceId(ecReference);
    }
  }, [location]);

  useEffect(() => {
    if (!orderReferenceId) return;
    const placeOrder = async () => {
      await placeTicketOrder();
    };

    placeOrder();
  }, [placeTicketOrder, orderReferenceId]);

  useEffect(() => {
    if (status === "error") {
      logger.error("[Ticketing] error placing ticket order in remo", {
        orderReferenceId,
        eventId: event?.id,
      });
    }

    if (status === "success") {
      const url = new URL(window.location.href);
      url.searchParams.delete("ec_reference");
      url.searchParams.append("proceedWithRegistration", "true");
      window.history.replaceState({}, "", url.toString());
    }
  }, [event?.id, orderReferenceId, status]);

  const handleContactUs = () => {
    callApi("showNewMessage");
  };

  if (status === "pending") {
    return (
      <PageLoadingWithDialog message={t("eventLanding:placing.ticket.order")} />
    );
  }

  if (status === "error") {
    return (
      <Dialog open>
        <Box className={styles.container}>
          <Typography>
            {t("eventLanding:error.placing.ticket.order")}
          </Typography>
          <Box className={styles.buttonsContainer}>
            <Button
              size="md"
              onClick={() => window.location.reload()}
              className={styles.button}
            >
              {t("event:reload")}
            </Button>
            <Button
              size="md"
              onClick={handleContactUs}
              variant="secondary"
              className={styles.button}
            >
              {t("common:contact.support")}
            </Button>
          </Box>
        </Box>
      </Dialog>
    );
  }

  return null;
};
